import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78d8fe96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userCenter" }
const _hoisted_2 = { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"center","margin-top":"20px"} }

import { ref, watchEffect } from "vue";
import API from "@/api";
import {
  getLoginUserUsingGet,
  userLogoutUsingGet,
  userUpdateUsingPost,
} from "@/api/userController";
import message from "@arco-design/web-vue/es/message";
import UserRetryPasswordModal from "@/views/user/components/UserRetryPasswordModal.vue";
import PictureUploader from "@/components/PictureUploader.vue";
import { FILE_BIZ } from "@/constant/file";
import { useRouter } from "vue-router";
import { useLoginUserStore } from "@/store/userStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCenter',
  setup(__props) {

const router = useRouter();
const form = ref({
  userAccount: "",
  userName: "",
  userAvatar: "",
  userProfile: "",
} as API.UserUpdateRequest);

/**
 * 加载数据
 */
const loadData = async () => {
  const res = await getLoginUserUsingGet();
  if (res.data.code === 200) {
    form.value = res.data.data as any;
  } else {
    message.error("登录失败，" + res.data.message);
  }
};

/**
 * 修改
 */
const handleSubmit = async () => {
  const res = await userUpdateUsingPost(form.value);
  if (res.data.code === 200) {
    message.success("修改成功");
  } else {
    message.error("修改失败，" + res.data.message);
  }
};

const loginUserStore = useLoginUserStore();
/**
 * 退出登录
 */
const handleLogout = async () => {
  const res = await userLogoutUsingGet();
  if (res.data.code === 200) {
    loginUserStore.removerLoginUser();
    message.success("退出登录成功");
  } else {
    message.error("退出登录失败，" + res.data.message);
  }
};

const userRetryPasswordModal = ref();

watchEffect(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_typography_title, { heading: 2 }, {
      default: _withCtx(() => [
        _createTextVNode(" 用户中心 ")
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: form.value,
      style: { width: '480px', margin: '0 auto' },
      "label-align": "left",
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: "账号",
          "validate-trigger": "input"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userAccount) = $event)),
              placeholder: "请输入账号..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "昵称",
          "validate-trigger": "input"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.userName) = $event)),
              placeholder: "请输入昵称..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "头像" }, {
          default: _withCtx(() => [
            _createVNode(PictureUploader, {
              biz: _unref(FILE_BIZ).USER_AVATAR,
              value: form.value.userAvatar,
              onChange: (value) => (form.value.userAvatar = value)
            }, null, 8, ["biz", "value", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "简介",
          "validate-trigger": "input"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userProfile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.userProfile) = $event)),
              placeholder: "请输入简介..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            "html-type": "submit",
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("修改")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            status: "danger",
            onClick: handleLogout,
            style: {"width":"120px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("退出登录")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_space, { style: {"display":"flex","width":"100%","align-items":"center","justify-content":"center","margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_link, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (userRetryPasswordModal.value.openModal()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("找回密码")
              ]),
              _: 1
            }),
            _createVNode(_component_a_link, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("返回首页")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(UserRetryPasswordModal, {
          ref_key: "userRetryPasswordModal",
          ref: userRetryPasswordModal
        }, null, 512)
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})